var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "itinerary itinerary-promo mb-3",
      class: { active: _vm.visible },
    },
    [
      _c("div", { staticClass: "itinerarySummary" }, [
        _c("div", { staticClass: "itinerarySummary__destinations" }, [
          _c("div", { staticClass: "row gy-5" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-xl-7 d-flex align-items-center justify-content-center",
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "itinerarySummary__number" }, [
                  _vm._v(
                    "\n            " + _vm._s(_vm.duration) + "\n            "
                  ),
                  _c("hr"),
                  _vm._v(" "),
                  _c("small", [
                    _vm._v(_vm._s(_vm.trainNumber)),
                    _vm.change ? _c("br") : _vm._e(),
                    _vm._v(_vm._s(_vm.change)),
                  ]),
                ]),
                _vm._v(" "),
                _vm._m(1),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-xl-5 d-flex align-items-center justify-content-center",
              },
              [
                _vm._m(2),
                _vm._v(" "),
                _vm.buyButton
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "itinerarySummary__button-std order-1 order-xl-2 mx-2",
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-warning",
                            attrs: { href: _vm.buyButton },
                          },
                          [_vm._v("Kup bilet")]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "itinerarySummary__destination itinerarySummary__destination--start",
      },
      [
        _c("div", [
          _c("div", { staticClass: "city" }, [
            _vm._v("\n                Warszawa centralna\n              "),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "itinerarySummary__destination itinerarySummary__destination--end",
      },
      [
        _c("div", [
          _c("div", { staticClass: "city" }, [
            _vm._v("\n                Warszawa centralna\n              "),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "itinerarySummary__price order-2 order-xl-1 mx-2" },
      [_c("strong", [_vm._v("od 49zł")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }